import { render, staticRenderFns } from "./SchoolsFilter.vue?vue&type=template&id=6c7f7a66"
import script from "./SchoolsFilter.vue?vue&type=script&setup=true&lang=js"
export * from "./SchoolsFilter.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports